import { Controller } from "@hotwired/stimulus"
import { syncGateReason } from "../lib/gate_reason"

// Step 5 Continue gate: disabled until each of monthly revenue, weekly lead volume, and primary goal is set (lead-mix slider not gated); OnboardingStepService#save_business_goals re-enforces server-side.
// Each group's "Custom" radio carries value="custom" paired with a hidden
// `custom` field holding the typed amount — selecting Custom only counts once
// that amount is filled.
const GROUPS = [
  { name: "business_goals[monthly_revenue_target]", custom: "business_goals[monthly_revenue_target_custom]", label: "monthly revenue goal" },
  { name: "business_goals[weekly_lead_volume_goal]", custom: "business_goals[weekly_lead_volume_goal_custom]", label: "weekly lead volume" },
  { name: "business_goals[primary_goal]",            custom: "business_goals[primary_goal_custom]",           label: "primary goal" }
]

export default class extends Controller {
  static targets = ["continueBtn", "statusMessage"]

  connect() {
    this._onChange = () => this.refresh()
    // `change` covers radio selection; `input` covers typing into the custom
    // amount field (its hidden value is updated in the target phase before this
    // bubble-phase listener reads it).
    this.element.addEventListener("change", this._onChange)
    this.element.addEventListener("input", this._onChange)
    this.refresh()
  }

  disconnect() {
    this.element.removeEventListener("change", this._onChange)
    this.element.removeEventListener("input", this._onChange)
  }

  refresh() {
    const missing = GROUPS.filter(g => !this.satisfiedFor(g)).map(g => g.label)
    const ready = missing.length === 0

    if (this.hasContinueBtnTarget) {
      syncGateReason(this.continueBtnTarget, { ready, reason: ready ? "" : this.missingMessage(missing) })
    }

    if (this.hasStatusMessageTarget) {
      if (ready) {
        this.statusMessageTarget.textContent = ""
        this.statusMessageTarget.classList.add("d-none")
      } else {
        this.statusMessageTarget.textContent = this.missingMessage(missing)
        this.statusMessageTarget.classList.remove("d-none")
      }
    }
  }

  satisfiedFor(group) {
    const checked = this.element.querySelector(`input[name="${group.name}"]:checked`)
    if (!checked) return false
    // "Custom" needs its paired amount filled; any preset selection is enough.
    if (checked.value === "custom") {
      const customInput = this.element.querySelector(`[name="${group.custom}"]`)
      return Boolean(customInput && customInput.value.trim())
    }
    return true
  }

  missingMessage(missing) {
    if (missing.length === 1) return `Set your ${missing[0]} to continue.`
    if (missing.length === 2) return `Set your ${missing[0]} and ${missing[1]} to continue.`
    return "Set your monthly revenue goal, weekly lead volume, and primary goal to continue."
  }
}
